// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","SearchResults":"je_a bhf_a bhf_j bhf_q bhf_st bhf_su bhf_w"};